module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image14.e65d9341.jpg";